import React from 'react'
import Faq_Banner from './faq-banner/Faq_Banner'
import ScrollToTop from '../scrolltotop/ScrollToTop'

const Faq = () => {
    return (
        
        <>
        <ScrollToTop/>
            <Faq_Banner />
        </>
    )
}

export default Faq